<template>
  <a-modal
    wrapClassName="customModal"
    v-model="activityModalData.showModal"
    :title="activityModalData.modalTitle"
    @ok="saveClassRoom"
    :width="width"
    cancelText="取消"
    okText="确定"
    :confirmLoading="submitLoading"
    :afterClose="afterClose"
    :destroyOnClose="true"
    :footer="null"
  >
    <a-form :form="form" :colon="false" layout="vertical" :label-col="labelCol">
      <a-row>
        <a-col :span="12">
          <a-form-item label="选择学校：">
            <a-select
              style="width: 300px; margin-top: -4px"
              v-decorator="[
                'selectSchoolId',
                {
                  initialValue: activityItem.schoolCode,
                  rules: [{ required: true, message: '请选择学校' }]
                }
              ]"
              placeholder="选择学校"
              showSearch
              optionFilterProp="children"
              @change="handleSelectSchoolChange"
              :getPopupContainer="(triggerNode) => triggerNode.parentNode"
              :disabled="activityModalData.option === 'edit' || activityModalData.option === 'relateLive'"
            >
              <a-select-option v-for="item in schoolList" :key="item.id" :value="item.schoolId">
                {{ item.schoolName }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="活动名称：">
            <a-input
              style="width: 300px; margin-top: -4px"
              placeholder="请输入活动名称"
              autocomplete="off"
              v-decorator="[
                'activityName',
                {
                  initialValue: activityItem.activityName || '',
                  rules: [
                    { required: true, message: '请输入活动名称' },
                    { max: 1000, message: '活动名称不超过1000个字' }
                  ]
                }
              ]"
              :maxLength="1000"
              allowClear
              :disabled="activityModalData.option === 'relateLive'"
            />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="12">
          <a-form-item label="活动类型：">
            <a-radio-group
              :disabled="activityModalData.option === 'edit' || activityModalData.option === 'relateLive'"
              v-decorator="[
                'activityType',
                {
                  initialValue: activityItem.activityType,
                  rules: [{ required: true, message: '请选择活动类型' }]
                }
              ]"
              @change="activityTypeChange"
            >
              <a-radio :value="2">翻转课堂</a-radio>
              <a-radio :value="1">直播/录像</a-radio>
            </a-radio-group>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="查看录像：">
            <a-radio-group
              :disabled="watchVideoDisabled || activityModalData.option === 'relateLive'"
              v-decorator="[
                'watchVideo',
                {
                  initialValue: activityItem.watchVideo,
                  rules: [{ required: true }]
                }
              ]"
              @change="watchVideoChange"
            >
              <a-radio :value="1">支持查看</a-radio>
              <a-radio :value="0">不支持查看</a-radio>
            </a-radio-group>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="12">
          <a-form-item label="活动时间：">
            <a-range-picker
              :disabled="activityModalData.option === 'relateLive'"
              style="width: 300px; margin-top: -4px"
              v-decorator="[
                'activityDate',
                {
                  initialValue: activityItem.startTime
                    ? [momentTime(activityItem.startTime, 'YYYY-MM-DD'), momentTime(activityItem.endTime, 'YYYY-MM-DD')]
                    : null,
                  rules: [{ required: true, message: '请选择活动时间' }]
                }
              ]"
              @change="activityDateChange"
            />
          </a-form-item>
        </a-col>
      </a-row>
      <div style="display: flex; margin-bottom: 0px" v-show="activityType == 1">
        <a-form-item label="" style="width: 320px; margin-bottom: 0px">
          <a-select
            mode="multiple"
            v-decorator="['schoolId']"
            placeholder="选择学校"
            showSearch
            optionFilterProp="children"
            @change="handleSchoolChange"
            :getPopupContainer="(triggerNode) => triggerNode.parentNode"
            :maxTagCount="2"
          >
            <a-select-option v-for="item in schoolList" :key="item.id" :value="item.schoolId">
              {{ item.schoolName }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="" style="width: 320px; margin-left: 16px">
          <a-range-picker @change="handleDateChange" :getPopupContainer="(triggerNode) => triggerNode.parentNode" />
        </a-form-item>
        <a-form-item label="" style="width: 200px; margin-left: 16px">
          <a-input
            style="width: 100%"
            placeholder="请输入直播名称或关键字"
            autocomplete="off"
            v-decorator="[
              'courseName',
              {
                rules: [{ max: 20, message: '标题不超过20个字' }]
              }
            ]"
            :maxLength="50"
            allowClear
            @keyup.native.enter.stop.prevent="reGetLiveLive"
          />
        </a-form-item>
      </div>
      <a-table
        v-show="activityType == 1"
        size="small"
        :columns="columns"
        :data-source="liveList"
        :pagination="false"
        :row-key="(record, index) => record.liveId"
        :loading="tabLoading"
        :row-selection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange
        }"
      >
        <template slot="liveStatus" slot-scope="text, record">
          <a-tag :color="record.liveStatus | filterActiveListStatusTag">{{ text }}</a-tag>
        </template>
      </a-table>
      <a-row v-show="activityType == 1" type="flex" justify="center" class="pagination">
        <div>
          已选直播数:（
          <span>{{ selectedRowKeys.length }}</span>
          ）
        </div>
        <a-pagination
          v-show="liveList.length != 0"
          show-quick-jumper
          show-size-changer
          :default-current="1"
          :total="totalCount"
          :defaultPageSize="5"
          :pageSizeOptions="['5', '10', '20']"
          v-model="pageNum"
          :pageSize.sync="pageSize"
          @change="handlePageChange"
          @showSizeChange="onShowSizeChange"
        />
      </a-row>
      <div class="blank" v-show="activityType == 2"></div>
      <div class="btn_box">
        <a-button type="default" style="margin-right: 16px" class="ZHIHUISHU_QZMD" @click="closeModal">取消</a-button>
        <a-button @click="saveClassRoom" type="primary" class="add_course_btn ZHIHUISHU_QZMD">
          {{ activityModalData.isEdit ? '确定保存' : '确定创建' }}
        </a-button>
      </div>
    </a-form>
  </a-modal>
</template>

<script>
import moment from 'moment'
const columns = [
  {
    title: '直播名称',
    align: 'center',
    dataIndex: 'liveName',
    scopedSlots: { customRender: 'liveName' }
  },
  {
    title: 'ID',
    // width: 90,
    dataIndex: 'liveId',
    scopedSlots: { customRender: 'liveId' }
  },
  {
    title: '状态',
    // width: 88,
    // minWidth: 88,
    dataIndex: 'liveStatus',
    scopedSlots: { customRender: 'liveStatus' }
  },
  {
    title: '主讲学校-教室',
    // width: 145,
    dataIndex: 'schoolNameAndClassName',
    scopedSlots: { customRender: 'schoolNameAndClassName' }
  },
  {
    title: '直播时间',
    // width: 145,
    dataIndex: 'startTime',
    scopedSlots: { customRender: 'startTime' }
  }
]

export default {
  props: {
    activityModalData: {
      type: Object,
      default: () => ({})
    },
    activityItem: {
      type: Object,
      default: () => ({})
    },
    width: {
      type: Number,
      default: () => 932
    }
  },
  filters: {
    filterActiveListStatusTag(liveStatus) {
      let res = 'blue'
      switch (String(liveStatus)) {
        case '未开始':
          res = 'blue'
          break
        case '进行中':
          res = 'green'
          break
        case '已结束':
          res = 'orange'
          break
      }
      return res
    }
  },
  watch: {
    activityModalData: {
      handler(nVal, oVal) {
        const { showModal, activityItem } = nVal
        this.$nextTick(() => {
          if (showModal) {
            // 初始化
            ;(this.selectedRowKeys = activityItem.liveId
              ? (activityItem.liveId || '').split(',').map((i) => Number(i))
              : []),
              (this.selectSchoolId = activityItem.schoolCode)
            this.watchVideoDisabled = activityItem.activityType == 1
            this.activityType = activityItem.activityType
            this.watchVideo = activityItem.watchVideo
          }
        })
      },
      deep: true
    }
  },
  data() {
    return {
      labelCol: { span: 5 },
      showModal: false,
      submitLoading: false,
      form: this.$form.createForm(this, { name: 'form' }),
      columns,
      liveList: [],
      tabLoading: false,
      totalCount: 0,
      pageNum: 1,
      pageSize: 5,
      activityType: 1,
      activityDate: [],
      watchVideo: 1,
      watchVideoDisabled: false,
      schoolList: [],
      selectedRowKeys: [],
      startTime: '',
      endTime: '',
      schoolCodes: [],
      selectSchoolId: ''
    }
  },
  mounted() {
    this.getLiveLive()
    this.getSchoolList()
  },
  methods: {
    activityDateChange(date, dateString) {
      console.log('activityDate', dateString)
      this.activityDate = dateString
    },
    watchVideoChange(e) {
      console.log('watchVideo', e.target.value)
      this.watchVideo = e.target.value
    },
    handleDateChange(date, dateString) {
      this.startTime = dateString[0]
      this.endTime = dateString[1]
      this.reGetLiveLive()
    },
    momentTime(time, format) {
      return moment(time, format)
    },
    handleSelectSchoolChange(value) {
      this.selectSchoolId = value
    },
    handleSchoolChange(value, option) {
      this.schoolCodes = value
      this.reGetLiveLive()
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
      console.log(6165, selectedRowKeys)
    },
    activityTypeChange(e) {
      this.activityType = e.target.value
      this.watchVideoDisabled = e.target.value == 1
      this.watchVideo = 1
      this.form.setFieldsValue({
        watchVideo: this.watchVideo
      })
    },
    handlePageChange(page, pageSize) {
      this.pageNum = page
      this.pageSize = pageSize
      this.getLiveLive()
    },
    onShowSizeChange(current, size) {
      this.pageNum = current
      this.pageSize = size
      this.getLiveLive()
    },
    async getSchoolList() {
      // 初始化各项的值
      try {
        let schoolRes = await this.$http.getSelectSchoolList()
        if (schoolRes.code !== 200) {
          throw '初始化学校失败!请稍候重试'
        } else {
          this.schoolList = schoolRes.rt || []
        }
      } catch (error) {
        // this.$message.error(error)
      }
    },
    reGetLiveLive() {
      this.pageNum = 1
      this.getLiveLive()
    },
    async getLiveLive() {
      try {
        let courseName = this.form.getFieldValue('courseName')
        let startTime = this.startTime
        let endTime = this.endTime
        let schoolId = this.schoolCodes

        let params = {
          courseName: courseName,
          liveStatus: '',
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          roomType: 0,
          startTime,
          endTime,
          schoolCodes: schoolId.join(','),
          sortType: 1
        }
        this.tabLoading = true
        let res = await this.$http.getLiveLive(params)
        this.tabLoading = false
        if (res.code != 200 || res.rt.resultStatus != 1)
          return this.$message.error(res.rt.resultMessage || '获取活动列表失败')
        this.liveList = res.rt?.list || []
        this.totalCount = res.rt.totalCount
      } catch (error) {
        console.log(error)
      }
    },
    saveClassRoom() {
      this.form.validateFields(async (error, values) => {
        if (!error) {
          let params = {
            activityName: values.activityName,
            liveIds: this.selectedRowKeys.join(','),
            schoolCode: values.selectSchoolId,

            watchVideo: values.watchVideo,
            activityType: values.activityType,
            startTime: values.activityDate[0].format('YYYY-MM-DD'),
            endTime: values.activityDate[1].format('YYYY-MM-DD')
          }
          if (this.activityModalData.isEdit) {
            let res = await this.$http.updateActivityInfo({
              ...params,
              activityId: this.activityItem.id
            })
            if (res.code != 200 || res.rt.resultStatus != 1) {
              return this.$message.error(res.rt.resultMessage || '更新失败')
            } else {
              this.$message.success('更新成功')
            }
          } else {
            let res = await this.$http.createActivity(params)
            if (res.code != 200 || res.rt.resultStatus != 1) {
              return this.$message.error(res.rt.resultMessage || '创建失败')
            } else {
              this.$message.success('创建成功')
            }
          }
          this.showModal = false
          this.$emit('refresh')
          this.$emit('close')
        }
      })
    },
    closeModal() {
      this.showModal = false
      this.selectedRowKeys = []
      this.schoolCodes = []
      this.$emit('close')
    },
    afterClose() {
      this.closeModal()
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .ant-form-item {
    margin-bottom: 12px;
  }
  .ant-radio-checked {
    .ant-radio-inner {
      border-color: #5f60d3;
      &::after {
        background-color: #5f60d3;
      }
    }
  }
  .ant-checkbox-checked {
    .ant-checkbox-inner {
      border-color: #5f60d3;
      background-color: #5f60d3;
      &::after {
        background-color: #5f60d3;
      }
    }
  }
  .ant-checkbox-indeterminate {
    .ant-checkbox-inner {
      &::after {
        background-color: #5f60d3;
      }
    }
  }
  .ant-pagination-item-active {
    border-color: #5f60d3;
    a {
      color: #5f60d3;
    }
  }
}
.blank {
  height: 338px;
}
.pagination {
  margin-top: 20px;
  position: relative;
  div {
    position: absolute;
    left: 0;
    top: 4px;
    span {
      color: #5f60d3;
    }
  }
}
.btn_box {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  button:nth-child(1) {
    width: 104px;
    height: 38px;
    border-radius: 4px;
    border: 1px solid #5f60d3;
    &:hover {
      color: #5f60d3;
    }
  }
  button:nth-child(2) {
    width: 104px;
    height: 38px;
    background: #5f60d3;
    border-radius: 4px;
    border: none;
  }
}
</style>
